var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPushPinSimple = function SvgIconPushPinSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.517 2.75H18a1 1 0 1 1 0 2h-.308l1.897 10.75h.661a1 1 0 0 1 0 2H13v5a1 1 0 1 1-2 0v-5H3.75a1 1 0 1 1 0-2h.661L6.308 4.75H6a1 1 0 0 1 0-2h1.517m.822 2L6.442 15.5h11.116L15.661 4.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPushPinSimple;